/** 80mm thermal receipt printer — standard paper width */
export const TOKEN_PAPER_WIDTH_MM = 80;

/** Screen/layout width matching 80mm at 96 DPI */
export const TOKEN_PAPER_WIDTH_PX = Math.round((TOKEN_PAPER_WIDTH_MM * 96) / 25.4);

export const TOKEN_CONTAINER_PADDING_PX = 8;
